var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"execution-step"},[(_vm.link && _vm.link.url)?_c('a',{staticClass:"execution-step__link",attrs:{"href":_vm.link.url}},[_vm._v(" "+_vm._s(_vm.link.text)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }